import {
    $get,
    $post
  } from '@/utils/http'
  // 风险防控
export default {
    // 思想道德风险
  getBisk(params) {
  console.log(123);
    return $post('/portal/review/moralityRisk/listReview', params)
   
    },
   //思想详情
  goDetail(params) {
    console.log(params);
      return $post('/portal/review/moralityRisk/getReviewById', params)
     
      },
  
  }
  